import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { shape, arrayOf, string } from 'prop-types';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { useScrollLock } from './hooks/useScrollLock';
import { CloseButton, CloseButtonIcon, Container, Content, ShareContainer, ShareOverlay } from './ShareLinks.styles';
import useProductShortenLink from './hooks/useProductShortenLink';
import ShareLinksModalContent from './components/ShareLinksModalContent';
var ShareLinks = function ShareLinks(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$device = staticProps.device,
    device = _staticProps$device === void 0 ? 'desktop' : _staticProps$device;
  var _usePublisher = usePublisher(),
    subscribe = _usePublisher.subscribe;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useScrollLock(device, isOpen);
  var onCloseShareActive = function onCloseShareActive() {
    return setIsOpen(false);
  };
  useEffect(function () {
    subscribe('sharelinksbutton:click', function () {
      return setIsOpen(true);
    });
  }, [subscribe]);
  var _useProductShortenLin = useProductShortenLink({
      active: isOpen,
      data: data,
      structure: structure
    }),
    oneLink = _useProductShortenLin.oneLink,
    magaly = _useProductShortenLin.magaly;
  if (!isOpen) {
    return null;
  }
  return React.createElement(ShareContainer, {
    "data-testid": "share-links"
  }, React.createElement(Container, {
    active: isOpen,
    device: device,
    "data-testid": "share-links-content"
  }, React.createElement(CloseButton, {
    "data-testid": "btn-close-modal",
    name: "Close",
    onClick: onCloseShareActive,
    color: "none",
    "aria-label": "fechar o modal"
  }, React.createElement(CloseButtonIcon, {
    name: "Close"
  })), React.createElement(Content, null, React.createElement(ShareLinksModalContent, {
    data: data,
    structure: structure,
    staticProps: staticProps,
    oneLink: oneLink,
    magaly: magaly,
    isOpen: isOpen
  }))), React.createElement(ShareOverlay, {
    "data-testid": "share-links-overlay",
    device: device,
    active: isOpen,
    onClick: onCloseShareActive
  }));
};
process.env.NODE_ENV !== "production" ? ShareLinks.propTypes = {
  data: shape({
    product: shape({
      image: string,
      title: string
    })
  }),
  "static": shape({
    device: string,
    sectionSharedBag: shape({
      buttonLabel: string,
      show: string,
      url: string
    }),
    sectionSocial: shape({
      buttons: arrayOf(shape({
        color: string,
        eventType: string,
        href: string,
        name: string
      })),
      title: string
    })
  }),
  structure: shape({})
} : void 0;
ShareLinks.defaultProps = {
  data: {},
  "static": {
    device: 'desktop',
    sectionSharedBag: {
      buttonLabel: 'Adicionar à Sacola Pronta',
      show: 'false',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    }
  },
  structure: {}
};
ShareLinks.ssr = false;
ShareLinks.displayName = 'ShareLinks';
ShareLinks.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
export default withLayoutProps(ShareLinks);